export default __webpack_public_path__ + "static/media/4.cbfa4708.svg";